import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// La page d'inscription est fusionnée avec la page de connexion.
// Ce composant redirige automatiquement vers /login.
const RegisterPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  useEffect(() => {
    const loginPath = slug ? `/event/${slug}/login` : '/login';
    navigate(loginPath, { replace: true });
  }, [slug, navigate]);

  return null;
};

export default RegisterPage;
